//@ts-ignore
import { CLESSON_MODES } from '@yandex-int/k-common/constants';
import React from 'react';

import { AssignmentDateTab } from './assignment__date-tab.component';

interface Props {
    activeSubscriptionSlug: string | null;
    disabled: boolean;
    lessonMode: CLESSON_MODES | null;
}

const container = React.memo((props: Props) => {
    return <AssignmentDateTab {...props} />;
});

container.displayName = 'AssignmentDateTabContainer';
export const AssignmentDateTabContainer = container;
